import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
const HOP_LINK = 'https://2a2c3etilm79k5v8phfdpkp51j.hop.clickbank.net';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleCtaClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function App() {
  useEffect(() => {
    // Inject Facebook Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '666521186552257');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-[#EDE8D0] text-[#2B1F14] relative overflow-hidden" data-id="element-0">
      {/* Grain texture overlay */}
      <div className="grain-overlay" aria-hidden="true" data-id="element-1" />

      <div className="relative z-10 mx-auto w-full max-w-[480px] px-6 py-10 sm:py-14" data-id="element-2">
        {/* HEADLINE */}
        <motion.header initial="hidden" animate="show" variants={fadeUp} className="text-center mb-8" data-id="element-3">
          <p className="text-[#C9A84C] text-xs uppercase tracking-[0.35em] mb-5 font-light" data-id="element-4">
            ✦ Ancient Ritual ✦
          </p>
          <h1 className="font-display font-bold text-[2rem] sm:text-4xl leading-[1.15] text-[#2B1F14] mb-5" data-id="element-5">
            Japanese Women Have Been Hiding This Tea Secret for{' '}
            <span className="italic text-[#C9A84C]" data-id="element-6">300 Years</span>
          </h1>
          <p className="text-[#2B1F14]/75 text-base leading-relaxed font-light" data-id="element-7">
            The morning ritual that's quietly changing bodies — and no one's
            talking about it.
          </p>
        </motion.header>

        {/* HERO IMAGE */}
        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} variants={fadeUp} className="relative mb-8 rounded-2xl overflow-hidden shadow-2xl ring-1 ring-[#C9A84C]/15" data-id="element-8">
          <img src="https://cdn.magicpatterns.com/uploads/tCSUU4UgHfhnSWB8ML5mi6/a72f99fa-8272-4705-9dd8-ac5236476034.png" alt="Steaming cup of herbal tea with dried leaves and petals in a warm forest setting" className="w-full h-72 sm:h-80 object-cover" data-id="element-9" />
          <div className="absolute inset-0 hero-vignette pointer-events-none" data-id="element-10" />
        </motion.div>

        {/* CURIOSITY HOOK */}
        <motion.p initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.5
      }} variants={fadeUp} className="font-display italic text-center text-lg sm:text-xl leading-relaxed text-[#2B1F14]/80 mb-10 px-2" data-id="element-11">
          It's not green tea. It's not matcha.
          <br data-id="element-12" />
          And it's definitely not what you've already tried.
        </motion.p>

        {/* CTA */}
        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.4
      }} variants={fadeUp} className="mb-6" data-id="element-13">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="cta-glow block w-full bg-[#C9A84C] hover:bg-[#D9B85C] text-[#1E1410] font-bold tracking-wider text-base sm:text-lg text-center py-5 px-6 rounded-full transition-colors duration-200" data-id="element-14">
            SHOW ME THE SECRET →
          </a>
          <p className="text-center text-[#2B1F14]/60 text-xs mt-4 tracking-wide" data-id="element-15">
            Over{' '}
            <span className="text-[#C9A84C] font-semibold" data-id="element-16">47,000 women</span>{' '}
            tried it this month
          </p>
        </motion.div>

        {/* TRUST BAR */}
        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.5
      }} variants={fadeUp} className="mt-12 pt-6 border-t border-[#2B1F14]/15" data-id="element-17">
          <div className="flex items-center justify-between gap-2 text-[#2B1F14]/70 text-[11px] sm:text-xs" data-id="element-18">
            <div className="flex items-center gap-1.5" data-id="element-19">
              <span data-id="element-20">🔒</span>
              <span data-id="element-21">Secure Page</span>
            </div>
            <span className="text-[#2B1F14]/25" data-id="element-22">·</span>
            <div className="flex items-center gap-1.5" data-id="element-23">
              <span data-id="element-24">⭐</span>
              <span data-id="element-25">4.9/5 Rating</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}